import React from "react";
import { useAuth } from "../context/AuthContext";
import { Sparkles } from "lucide-react";

export const BetaBanner = () => {
  const { billingLive } = useAuth();
  if (billingLive) return null;
  return (
    <div className="bg-ink text-sand-light" data-testid="beta-banner">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-2.5 flex items-center justify-center gap-2 text-center text-xs sm:text-sm">
        <Sparkles size={15} className="text-ochre shrink-0" />
        <span>
          <span className="font-bold text-ochre">Beta · Coming soon</span> — every premium feature is{" "}
          <span className="font-bold">free for everyone</span> while we finish setting up payments. Enjoy!
        </span>
      </div>
    </div>
  );
};
